import _ from "lodash";
import {
    handleChangeActionType,
    handleChangeAllActionType,
    handleChangeToInitStateActionType
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  fraDato: "",
  tilDato: "",
  fraDatoValidationErrorText: null,
  tilDatoValidationErrorText: null
};

export default function antallIleggelserPerIleggelsetypeFilterFormReducer(
  state = {
    ...INITIAL_STATE,
    validationError: { ...INITIAL_STATE.validationError }
  },
  action
) {
  switch (action.type) {
    case handleChangeActionType(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_FILTER_FORM"
    ):
      _.set(state, action.variableName, action.payload);
      return { ...state };
    case handleChangeAllActionType(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_FILTER_FORM"
    ):
      return { ...action.payload };
    case handleChangeToInitStateActionType(
      "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_FILTER_FORM"
    ):
      return {
        ...INITIAL_STATE,
        validationError: { ...INITIAL_STATE.validationError }
      };
    default:
      return state;
  }
}
